/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Module, $, SCS) {
	'use strict';

	var SearchClusterSuggestions = Module.extend({
		// The container module instance (for setting config changes and the like)
		searchContainer: null,
		// The search processor instance for getting the cluster suggestions
		searchProcessor: null,

		on: function(callback) {
			callback();
		},

		after: function() {
			this.findElements();
			this.attachListeners();
		},

		initSearch: function(searchContainer) {
			var mod = this;

			mod.searchContainer = searchContainer;

			var $config = mod.$ctx.closest('.search-configuration');
			if(!$config.length) {
				// Configuration on search field could also be outside
				$config = searchContainer.$config;
			}

			mod.searchProcessor = SCS.search.orchestration.forClusterSuggestions(
				$config.attr('data-sitesearch-gsahostname'),
				$config.attr('data-sitesearch-sites'),
				$config.attr('data-sitesearch-client'),
				$('html').attr('lang') || 'de'
			);
			mod.searchProcessor.responder(SCS.search.util.respondTo({
				data: mod.clusterData
			}, mod));
			mod.searchProcessor.responder(SCS.search.util.respondTo({
				data: searchContainer.stopLoading,
				error: searchContainer.stopLoading,
				abort: searchContainer.stopLoading
			}, searchContainer));
		},

		searchConfigChanged: function(searchConfig) {
			this.searchContainer.startLoading();
			this.searchProcessor.process(searchConfig);
		},

		clusterData: function(processor, data, config) {
			var clusters = data.clusters || [];
			clusters = clusters[0] || {};
			clusters = clusters.clusters || [];
			if(clusters.length < this.minSearchResults) {
				clusters = [];
			}
			clusters = clusters.slice(0, this.maxSearchResults);

			this.$ctx.toggleClass('active', !!clusters.length);
			this.$title.text(SCS.utils.formatString(
				this.titleFormat,
				config.query
			));

			var snabbdom = window.snabbdom;
			var h = snabbdom.h;

			var listSize = Math.ceil(this.maxSearchResults/2);
			var lists = [];
			while(clusters.length) {
				lists.push(this.renderList(clusters.splice(0, listSize), processor, config, h));
			}

			this.resultContainer = snabbdom.patch(this.resultContainer, h('div.scs-sitesearch-cluster-suggestions-results', lists));
		},

		renderList: function(clusters, processor, config, h) {
			var items = [];
			for(var i=0;i<clusters.length;i+=1) {
				var cluster = clusters[i];
				items.push(h(
					'li',
					[
						h(
							'a',
							{
								props: {
									href: '#'+SCS.search.util.param({q: cluster.label})
								},
								on: {
									click: [this.trackClick, cluster, processor, config]
								}
							},
							[cluster.label]
						)
					]
				));
			}
			return h(
				'ul',
				items
			);
		},

		trackClick: function(cluster, processor, config) {
			Module.SearchResultContainer.trackClick(
				'cluster',
				config,
				{
					previousQuery: config.query,
					query: cluster.label,
					url: document.location.href
				},
				processor
			);
		},

		findElements: function() {
			this.minSearchResults = Math.max(1, this.$ctx.data('minSearchResults') || 0);
			this.maxSearchResults = this.$ctx.data('maxSearchResults') || 8;
			this.titleFormat = this.$ctx.attr('data-title');
			this.$title = this.$ctx.find('div.title h3');
			this.resultContainer = this.$ctx.find('.scs-sitesearch-cluster-suggestions-results')[0];
		},

		attachListeners: function() {
		}

	});

	Module.SearchClusterSuggestions = SearchClusterSuggestions;

})(window.Tc.Module, window.Tc.$, window.SCS = window.SCS || {});

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchClusterSuggestions.js
// module id = 56
// module chunks = 0